import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaCogs, FaBolt, FaShieldAlt } from "react-icons/fa";

function Inovance() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  return (
    <>
      {/* Page Header */}
      <div className="container-fluid page-header py-5 animate__animated animate__fadeIn">
        <div className="container py-5">
          <h1 className="display-3 text-white animate__animated animate__slideInRight">
            Inovance
          </h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb animate__animated animate__slideInRight mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/">Products</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Inovance
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <Container className="py-5">
        {/* Header Section */}
        <Row className="justify-content-center mb-5">
          <Col xl={8} lg={10} className="text-center">
            <h1
              className="text-gradient-primary fs-1 text-center fw-bold mt-1 "
              data-aos="fade-left"
            >
              Welcome to <span className="text-danger">Inovance</span>
            </h1>
          </Col>
        </Row>

        {/* Content Section */}
        <Row className="align-items-center g-5">
          {/* Image Column */}
          <Col lg={6} className="order-lg-1 order-2">
            <div className="position-relative rounded-4 overflow-hidden shadow">
              <img
                src={require("../assets/img/products/Inovance/csm_WIN_3_96ee5ea7e6.png")}
                alt="Inovance Technology"
                className="img-fluid w-100"
                style={{ minHeight: "400px", objectFit: "cover" }}
              />
              <div className="position-absolute bottom-0 start-0 end-0 p-3 bg-dark bg-opacity-75 text-white text-center">
                <h5 className="mb-0">Industrial Automation Solutions</h5>
              </div>
            </div>
          </Col>

          {/* Text & Cards Column */}
          <Col lg={6} className="order-lg-2 order-1">
            <div className="ps-lg-4">
              <p className="fs-6 mb-4 justified-text">
                Inovance delivers high-performance automation products including
                AC drives, servo motors, PLCs, and CNC solutions for Industry
                4.0 applications.
              </p>

              {/* Feature Cards */}
              <Row className="g-4">
                <Col md={6}>
                  <div className="card border-0 shadow-sm hover-shadow transition-all">
                    <div className="card-header bg-danger text-white text-center ">
                      <i className="bi bi-globe fs-3"></i>
                    </div>
                    <div className="card-body text-center py-4">
                      <h5 className="fw-bold mb-3">Global Reach</h5>
                      <p className="fs-6 small mb-0">
                        Serving clients in 60+ countries with localized support
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="card border-0 shadow-sm hover-shadow transition-all">
                    <div className="card-header bg-danger text-white text-center ">
                    <i class="fa-solid fa-lightbulb fs-3"></i>
                    </div>
                    <div className="card-body text-center py-4">
                      <h5 className="fw-bold mb-3">Innovation</h5>
                      <p className="fs-6 small mb-0">
                        Continuous R&D investment for cutting-edge in the
                        solutions
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="card border-0 shadow-sm hover-shadow transition-all">
                    <div className="card-header bg-danger text-white text-center ">
                    <i class="fa-solid fa-bullseye fs-3"></i>
                    </div>
                    <div className="card-body text-center py-4">
                      <h5 className="fw-bold mb-3">Precision</h5>
                      <p className="fs-6 small mb-0">
                        Sub-millimeter accuracy for critical applications
                      </p>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="card border-0 shadow-sm hover-shadow transition-all">
                    <div className="card-header bg-danger text-white text-center ">
                    <i class="fa-solid fa-shield fs-3"></i>
                    </div>
                    <div className="card-body text-center py-4">
                      <h5 className="fw-bold mb-3">Reliability</h5>
                      <p className="fs-6 small mb-0">
                        99.9% uptime guarantee for industrial operations
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
      <div
        className=" mb-5 py-5"
        style={{
          background: "url('/images/bg-pattern.jpg')",
          backgroundSize: "cover",
        }}
      >
        <Row className="justify-content-center">
          <Col lg={8} md={10}>
            <Card
              className="shadow-lg border-0 rounded-3 p-4 bg-white"
              style={{ maxWidth: "100%" }}
            >
              <Card.Body className="text-center">
                <h2 className="fw-bold text-danger mb-3">
                  High-Performance Servo Systems
                </h2>
                <p className="fs-6">
                  Inovance's servo systems revolutionize industrial automation
                  with precision motion control solutions. Our advanced servo
                  drives and motors deliver exceptional accuracy (±0.01mm) for
                  demanding applications.
                </p>
                <Row className="text-center mt-4">
                  <Col md={4}>
                    <FaCogs size={40} className="text-danger mb-2" />
                    <h5 className="fw-bold">Precision Control</h5>
                    <p className="small fs-6">
                      Ensures high accuracy for CNC, packaging, and robotics.
                    </p>
                  </Col>
                  <Col md={4}>
                    <FaBolt size={40} className="text-danger mb-2" />
                    <h5 className="fw-bold">Energy Efficiency</h5>
                    <p className="small fs-6">
                      Reduces energy consumption by up to 30%.
                    </p>
                  </Col>
                  <Col md={4}>
                    <FaShieldAlt size={40} className="text-danger mb-2" />
                    <h5 className="fw-bold">Robust Design</h5>
                    <p className="small fs-6">
                      IP65-rated for durability in tough environments.
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <Row className="align-items-stretch g-4">
        {/* Left Column - Product Overview */}
        <Col lg={6} md={12}>
          <div className="h-100 mx-2 d-flex flex-column">
            {/* Product Card */}
            <div className="p-4 rounded-4 shadow-sm bg-white mb-4 flex-grow-1 border-start border-danger border-5 bg-gradient bg-opacity-10">
              <h3 className="text-danger fw-bold text-gradient-primary mb-4 pb-2 border-bottom border-danger border-2">
                Medium Voltage AC Drives
              </h3>
              <p className="mb-0 fs-6 lh-base">
                Innovance's Medium Voltage (MV) AC Drives are engineered for
                high-power applications that require precision, efficiency, and
                reliability. These drives optimize energy consumption, improve
                motor control, and extend equipment lifespan across industries
                like manufacturing, oil & gas, mining, and power generation.
              </p>
            </div>

            {/* Product Image */}
            <div className="rounded-4 shadow overflow-hidden position-relative">
              <img
                src={require("../assets/img/products/Inovance/10002.jpg")}
                alt="Inovance Medium Voltage Drive"
                className="img-fluid w-100 h-auto"
              />
              <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-25 d-flex align-items-center justify-content-center opacity-0 hover-opacity-100 transition-all">
                <button className="btn btn-danger rounded-pill px-4 py-2">
                  <i className="bi bi-zoom-in me-2"></i>View Details
                </button>
              </div>
            </div>
          </div>
        </Col>

        {/* Right Column - Features */}
        <Col lg={6} md={12}>
          <div className="h-100 d-flex flex-column">
            {/* Features Header */}
            <div className="text-center mt-2 mb-2">
              <h4 className="fw-bold fs-3 pb-2  text-gradient-primary border-bottom border-danger border-2 d-inline-block">
                What Sets Us Apart
              </h4>
              <p className="fs-6 mt-2">
                Cutting-edge technology for industrial excellence
              </p>
            </div>

            {/* Feature Cards */}
            <Row className="g-4 mb-4">
              <Col md={4} sm={6} xs={12} className="mt-5">
                <div className="card border-0 h-100 shadow-hover">
                  <div className="card-body p-0 d-flex flex-column">
                    <div className="bg-danger text-white p-1 rounded-top text-center">
                      <i className="bi bi-lightning-charge fs-1"></i>
                    </div>
                    <div className="p-3 flex-grow-1">
                      <h5 className="card-title fw-bold text-center mt-2">
                        High Efficiency
                      </h5>
                      <ul className="card-text small text-muted mt-3 ps-3">
                        <li className="mb-2 fs-6">
                          Advanced power conversion technology
                        </li>
                        <li className="mb-2 fs-6">
                          Maximizes energy efficiency
                        </li>
                        <li className="fs-6">
                          Reduces power losses significantly
                        </li>
                      </ul>
                    </div>
                    <div className="px-3 pb-3 text-center">
                      <span className="badge bg-danger bg-opacity-10 text-danger rounded-pill">
                        <i className="bi bi-check-circle me-1"></i>60+ Countries
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4} sm={6} xs={12} className="mt-5">
                <div className="card border-0 h-100 shadow-hover">
                  <div className="card-body p-0 d-flex flex-column">
                    <div className="bg-danger text-white p-1 rounded-top text-center">
                      <i className="bi bi-transparency fs-1"></i>
                    </div>
                    <div className="p-3 flex-grow-1">
                      <h5 className="card-title fw-bold text-center mt-2">
                        Wide Power Range
                      </h5>
                      <ul className="card-text small text-muted mt-3 ps-3">
                        <li className="mb-2 fs-6">
                          3.3kV to 11kV voltage support
                        </li>
                        <li className="mb-2 fs-6">500 kW to 20 MW capacity</li>
                        <li className="fs-6">Heavy-duty industrial ready</li>
                      </ul>
                    </div>
                    <div className="px-3 pb-3 text-center">
                      <span className="badge bg-danger bg-opacity-10 text-danger rounded-pill">
                        <i className="bi bi-award me-1"></i>R&D Excellence
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col md={4} sm={6} xs={12} className="mt-5">
                <div className="card border-0 h-100 shadow-hover">
                  <div className="card-body p-0 d-flex flex-column">
                    <div className="bg-danger text-white p-1 rounded-top text-center">
                      <i className="bi bi-cpu fs-1"></i>
                    </div>
                    <div className="p-3 flex-grow-1">
                      <h5 className="card-title fw-bold text-center mt-2">
                        Advanced Control
                      </h5>
                      <ul className="card-text small text-muted mt-3 ps-3">
                        <li className="mb-2 fs-6">
                          Precise speed/torque regulation
                        </li>
                        <li className="mb-2 fs-6">Vector control technology</li>
                        <li className="fs-6">Supports all motor types</li>
                      </ul>
                    </div>
                    <div className="px-3 pb-3 text-center">
                      <span className="badge bg-danger bg-opacity-10 text-danger rounded-pill">
                        <i className="bi bi-precision-cut me-1"></i>±0.01mm
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      {/* <!-- Industry Solutions Section --> */}
      <section class="" id="solutions">
        <div class="p-5">
          <div class="text-center text-gradient-primary mb-1">
            <h2 class="fw-bold text-danger mb-1">
              Our Industry-Specific Solutions
            </h2>
          </div>

          <div class="row g-4 mt-5">
            {/* <!-- Industrial Automation --> */}
            <div class="col-md-6 col-lg-4 ">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-industry me-2"></i> Industrial Automation
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Boost efficiency in manufacturing and assembly lines with
                    our{" "}
                    <strong>
                      high-speed servo drives, PLCs, and motion controllers
                    </strong>{" "}
                    designed for seamless automation.
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>

            {/* <!-- CNC & Machine Tools --> */}
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-cogs me-2"></i> CNC & Machine Tools
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Achieve unparalleled accuracy in machining with{" "}
                    <strong>high-precision servo motors</strong> and control
                    systems that deliver{" "}
                    <strong>±0.01mm positioning accuracy</strong>.
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>

            {/* <!-- Packaging & Logistics --> */}
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-box me-2"></i> Packaging & Logistics
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Enhance speed and reliability in packaging lines with{" "}
                    <strong>high-speed motion control systems</strong>, ensuring
                    smooth material handling and reduced downtime.
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>

            {/* <!-- Robotics & Smart Factories --> */}
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-robot me-2"></i> Robotics & Smart Factories
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Power advanced robotics with our{" "}
                    <strong>intelligent motion control solutions</strong>,
                    enabling{" "}
                    <strong>
                      seamless synchronization, smooth movement, and real-time
                      precision
                    </strong>
                    .
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>

            {/* <!-- Automotive & EV Manufacturing --> */}
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-car me-2"></i> Automotive & EV
                    Manufacturing
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Support the transition to{" "}
                    <strong>smart automotive production</strong> with{" "}
                    <strong>servo systems and controllers</strong> designed for{" "}
                    <strong>
                      high-speed assembly, welding, and precision machining
                    </strong>
                    .
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>

            {/* <!-- Heavy Machinery & Construction --> */}
            <div class="col-md-6 col-lg-4 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-header bg-danger text-white">
                  <h5 class="mb-0">
                    <i class="fas fa-tools me-2"></i> Heavy Machinery &
                    Construction
                  </h5>
                </div>
                <div class="card-body">
                  <p class="card-text fs-6">
                    Ensure durability and performance in rugged environments
                    with <strong>IP65-rated servo systems</strong> built to
                    withstand dust, vibration, and extreme temperatures.
                  </p>
                  {/* <a href="#" class="btn btn-outline-primary">Learn More</a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Why Choose Section --> */}
      <section class=" bg-light" id="why-choose">
        <div class="">
          <div class="text-center mb-5">
            <h2 class="fw-bold text-danger">Why Choose Inovance?</h2>
          </div>

          <div class="row g-4">
            <div class="col-md-6 col-lg-3 mb-4">
              <div class="bg-white p-4 text-center rounded shadow-sm h-100">
                <i class="fas fa-bullseye text-danger fs-1 mb-3"></i>
                <h5>Industry-Leading Precision</h5>
                <p class="mb-0 fs-6">Achieve micrometer-level accuracy</p>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4">
              <div class="bg-white p-4 text-center rounded shadow-sm h-100">
                <i class="fas fa-leaf text-danger fs-1 mb-3"></i>
                <h5>Energy Efficiency</h5>
                <p class="mb-0 fs-6">
                  Reduce power consumption by up to <strong>30%</strong>
                </p>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4">
              <div class="bg-white p-4 text-center rounded shadow-sm h-100">
                <i class="fas fa-shield-alt text-danger fs-1 mb-3"></i>
                <h5>Robust & Reliable</h5>
                <p class="mb-0 fs-6">
                  Designed to perform in <strong>harsh environments</strong>
                </p>
              </div>
            </div>

            <div class="col-md-6 col-lg-3 mb-4">
              <div class="bg-white p-4 text-center rounded shadow-sm h-100">
                <i class="fas fa-sliders-h text-danger fs-1 mb-3"></i>
                <h5>Custom Solutions</h5>
                <p class="mb-0 fs-6">
                  Tailored automation products for{" "}
                  <strong>specific industry needs</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Inovance;
